import { 
    logState, 
    initState,
} from './state.js';

import { actions } from './actions/action-config.js';
import * as eventHandlers from './event-handlers.js';
import * as bookingSummary from './ui/checkout-summary.js';

// Optional Modules
import * as motorhomeMod from './custom_extras/motorhome/motorhome.js';
import * as multiBookingMod from './ui/multi-booking/summary-multi-booking-accordion.js';
import * as sensibleWeatherMod from './custom_extras/sensible_weather/sensible-weather.js';
import { setStageOne } from './event-handlers.js';

import { calendar } from './checkout-visual-calendar.js';
import { initStageVisibility } from './stage-visibility.js';

// TODO: temporarily exposing needed functions to checkout.js through the global scope
import exposeGlobalFuncsToLegacy from './legacy-interface.js';
import { runAction, runActionPhase } from './actions/action-functions.js';
// import { fetchSetTerms } from './api/api.js';
import './ui/timer.js';
// import { loadModule } from './module-loader.js';




// TODO: FOR TESTING PURPOSES, REMOVE WHEN DONE
export { logState }; 

let HAS_RUN = false;

/**
 * Initialises the state of checkout, and the prospective booking if the user is coming from a client site
 * @param {*} data - data comprising the initial state of a booking
 * @returns void
 */
export function initCheckout(data = null) {    
    // If init has already run, return 
    if (HAS_RUN) {
        console.error('Checkout already initialised');
        return;
    }

    HAS_RUN = true;

    // Set checkout stage to first stage in stages array (booking)
    if (!data) {
        console.error('No data passed: Cannot initialise Checkout');
    }
    
    data['currentStageId'] = data.uiData.stages[0].id;

    // Init clientData
    // TODO: change the name of initState to reflect that we are updating client data section of state - units/categories/sites/etc - and not the entirety of state
    initState(data);
    initStageVisibility();
    
    // Load optional modules
    initModules(data.modules);        
 
    // TODO: currently exposing some of the functionality in refactored checkout to checkout.js - come back and remove this when possible
    exposeGlobalFuncsToLegacy();

    // Initialise booking summary    
    bookingSummary.init();
    calendar.init();
    
    // If the user has come from a customer's site with a partial booking, load it into checkout
    if (data.mode == "preset") {
        const booking = formatPresetBookingData(data.booking);
        
        // TODO: not sure if preset booking business logic belongs in the action_config
        // perhaps move it into a plain ol' setup function
        actions['preset_booking'].set(data.uiData.stage_1_field_config, booking);
    }

    // Set up all event listeners 
    eventHandlers.init();
    console.log('setting stage 1');
    // TODO: not a fan of this as setting fields in stage 1 outside of the preset is edge case
    if (data.mode !== "preset")
        setStageOne(data);
}

function formatPresetBookingData(bookingData) {
    return {
        site                : bookingData.preset_site,
        category            : bookingData.category,
        unit                : bookingData.unit,
        sub_unit            : bookingData.sub_unit ?? null,
        party_members       : bookingData.party_members,
        arrival_date        : bookingData.short_arrival_date,
        departure_date      : bookingData.short_departure_date,
        arrival_date_ymd    : bookingData.long_arrival_date,
        departure_date_ymd  : bookingData.long_departure_date,
        period              : parseIntb10(bookingData.period),
        preset_party_size   : bookingData.preset_party_size,
        pets_filter_active  : Number(bookingData.preset_pets) > 0,
        addons              : {},
        is_booking_available: bookingData.is_booking_available,
        missing_arrival_date: bookingData.missing_arrival_date,
        av_sub_units        : bookingData.av_sub_units,
        costs               : bookingData.costs,
        restrict_sub_unit_period: bookingData.restrict_sub_unit_period,
        terms               : bookingData.terms_and_conditions
    }
}

function initModules(modulesConfig) {
    if (modulesConfig?.motorhome_hire) {
        motorhomeMod.init();
    }

    if (modulesConfig?.multiple_booking) {
        multiBookingMod.init();
    }

    if (modulesConfig?.sensible_weather) {
        sensibleWeatherMod.init();
    }
}
